<template>
  <div class="pro">
    <div class="arrow-up"></div>
    <div class="big">
      <div class="pro_content" v-if="users != null">
        <div class="pro_username">
          <div class="pro_name">
            <span>{{ users.nickname }} 
              <span v-if="users.is_vip != 0" class="user_type">专业用户</span>
              <span v-else class="user_type">普通用户</span>
            </span>
          </div>
        </div>
        <div class="renew">
          <span class="span" v-if="users.is_vip != 0">到期时间·<span style="color: #e75353;">{{ users.expiration_time_text }}</span>到期</span>
          <span class="span" v-else>到期时间·<span style="color: #e75353;">{{ users.expiration_time_text }}</span> 到期</span>
          <el-button v-if="users.is_vip != 0" color="#3160eb" class="xf_btn" @click="openRenew">续费</el-button>
          <el-button v-else color="#3160eb" class="xf_btn" @click="userUpgradation">账户升级</el-button>
        </div>
        <div class="space" v-if="users.is_vip != 0">
          <Capacity/>
        </div>
        <el-button class="c_outBtn" @click="outlogin">退出登录</el-button>
      </div>
    </div>
  </div>

  <el-dialog v-model="renewModal" title="续费" class="renewModal" @close="closeRenewModal">
    <div class="renew_box" v-if="renewModal">
      <el-table :data="tableData">
        <el-table-column prop="level" label="等级"></el-table-column>
        <el-table-column prop="expiration_time" label="当前到期时间"></el-table-column>
        <el-table-column prop="" label="续费时长">
          <span>1 年</span>
        </el-table-column>
        <el-table-column prop="renewtime" label="续费后到期时间："></el-table-column>
      </el-table>
    </div>
  <div class="qr_code_box" v-if="codeImg != ''">
    <div class="box_border">
      <qrcode-vue class="qrcodeImg" :value="codeImg" :size="size" level="H" />
      <span class="text">下单成功！请扫码支付金额{{costVal}}元</span>
    </div>
  </div>
    <template #footer >
      <span class="dialog-footer" v-if="!hideFooter">
        <el-button link>费用：{{ costVal }}元</el-button>
        <el-button type="primary" @click="modalConfirm">确定下单</el-button>
      </span>
    </template>
  </el-dialog>

</template>

<script>
import Capacity from '@/components/capacity/capacity.vue';
import QrcodeVue from 'qrcode.vue';
import { ElMessage } from 'element-plus';
import { userRenewAPI, scanCodePaymentRenewAPI } from '@/api/api';
export default {
  components: { Capacity, QrcodeVue },
  props: ['userMsg'],
  data() {
    return {
      renewModal: false,
      userRenewInfo: null,
      codeImg: '',
      size: 150,
      currentType: null,
      tableData: [],
      costVal: 0,
      hideFooter: false,
      users: null,
    }
  },
  methods:{    
    /** 退出登录 */
    outlogin(){
      localStorage.removeItem('token');
      this.$router.push('/login');
    },
    /** 续费 */
    openRenew(){
      this.renewModal = true;
      this.currentType = 'T0202'
      let obj = {
        renew: 1,
      }
      userRenewAPI(obj).then((res)=>{
        console.log(res);
        // this.userRenewInfo = res.data;
        this.costVal = res.data.cost;
        this.tableData.push(res.data);
      })
    },
    /** 扫码支付 */
    modalConfirm(){
      let obj = {
        type: this.currentType,
        amount: this.costVal,
      }
      scanCodePaymentRenewAPI(obj).then((res)=>{
        console.log(res);
        this.codeImg = res.data.code_url;
        this.hideFooter = true;
      })
    },
    /** 关闭 */
    closeRenewModal(){
      this.costVal = 0;
      this.tableData = [];
      this.codeImg = '';
    },
    /** 账户升级 */
    userUpgradation(){
      ElMessage({
        message: '功能正在筹备，敬请期待！',
        type: 'warning',
      })
    }
  },
  mounted(){
    // this.openRenew()
  },
  watch:{
    userMsg: {
      immediate: true,
      handler(newVal){
        console.log("user",newVal)
        this.users = newVal;
      },
      deep: true,
    },
  }
}
</script>

<style lang="scss">
.pro {
  width: 200px;
  background: white;
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 5px solid transparent; /* 左边框的宽 */
    border-right: 5px solid transparent; /* 右边框的宽 */
    border-bottom: 5px solid #ffffff; /* 下边框的长度|高,以及背景色 */
    font-size: 0;
    line-height: 0;
    position: relative;
    left: 50%;
    background: white;
    box-shadow: 0px 0px 6px #e2e2e2;
  }
  .big {
    border: none;
    border-radius: 5px;
    bottom: -248px;
    .pro_content {
      width: 100%;
      margin: 0 auto;
      .pro_name {
        padding-bottom: 10px;
        font-size: 14px;
        text-align: left;
        border-bottom: 1px solid #f3f3f3;
        font-weight: bold;
        .user_type{
          font-size: 12px;
          font-weight: 500;
          color: #9f9f9f;
        }
      }
      .renew {
        width: 100%;
        text-align: left;
        padding-bottom: 10px;
        border-bottom: 1px solid #f3f3f3;
        .span {
          display: inline-block;
          line-height: 30px;
          font-size: 13px;
        }
        .xf_btn{
          width: 100%;
        }
        
      }
      .space {
        position: relative;
        margin-top: 5px;
        span {
          // position: relative;
          // top: -15px;
          // text-align: center;
          // right: 39px;
        }
        .btn {
          width: 100%;
          button {
            width: 88%;
            margin-right: 6%;
            background: #4edf8f;
            color: white;
            border-radius: 5px;
            border: none;
            font-size: 19px;
            line-height: 36px;
            position: relative;
            top: -8px;
          }
        }
      }      
      .c_outBtn{
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}

.renewModal{
  text-align: left;
  .renew_box{
    padding: 10px;
  }
}

.qr_code_box{
  // position: fixed;
  // top: 50%; left: 50%;
  // transform: translate(-50%,-50%);
  margin-top: 20px;
  // display: flex;
  // align-items: flex-start;
  // justify-content: center;
  text-align: center;
  width: 100%;
  .box_border{
    border: 1px solid #d9d9d9;
    width: 200px;
    margin: 0 auto;
    padding: 16px 0;
    border-radius: 10px;
  }
  .text{
    display: block;
    margin-top: 5px;
  }
}
</style>